"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineSpectrumRanking = exports.SpectrumRanking = void 0;
const lib_es2015_1 = require("@hodol/web-component-helper/lib-es2015");
const apis_1 = require("./apis");
const lib_es2015_2 = require("@hodol/dom-helper/lib-es2015");
class SpectrumRanking extends HTMLElement {
    constructor() {
        super();
        this.spectrumApis = new apis_1.default();
        this.number = Number((0, lib_es2015_2.getAttributeOrThrowError)(this, 'number'));
        this.windowSize = Number((0, lib_es2015_2.getAttributeOrThrowError)(this, 'window-size'));
        this.hypotheticalSpectrum = (0, lib_es2015_2.getAttributeOrThrowError)(this, 'hypothetical-spectrum');
        this.visualBarFactor = 0.8;
        this.style.setProperty('display', 'grid');
        this.style.setProperty('grid-template-columns', 'auto 1fr');
        this.style.setProperty('margin-top', '1rem');
        this.innerHTML = '';
    }
    connectedCallback() {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.spectrumApis.getSpectraFacet(this.number, this.windowSize);
            if (resp === null) {
                alert(`fail to get spectrum facet, number: ${this.number}, window: ${this.windowSize}`);
                return;
            }
            const spectraFacet = Object.keys(resp).map(spectrum => ({ spectrum, count: resp[spectrum] })).sort((a, b) => a.count > b.count ? -1 : 1);
            spectraFacet.forEach(item => {
                this.appendChild((0, lib_es2015_2.buildNodeByOuterHTML)(`<div>${item.spectrum}</div>`));
                this.appendChild((0, lib_es2015_2.buildNodeByOuterHTML)(`<div><div style="width: ${item.count * this.visualBarFactor}rem; background-color: ${this.hypotheticalSpectrum === item.spectrum ? 'red' : item.spectrum.startsWith(`${this.hypotheticalSpectrum.split('-')[0]}-`) ? 'coral' : 'green'}; height: 100%; color: white;">${item.count}</div></div>`));
            });
        });
    }
}
exports.SpectrumRanking = SpectrumRanking;
const defineSpectrumRanking = (name) => {
    (0, lib_es2015_1.defineIfUndefined)(name, SpectrumRanking);
};
exports.defineSpectrumRanking = defineSpectrumRanking;
